<div class="poster-view" [ngStyle]="posterViewBackgroundStyle">
  <div class="poster-text-view">
      <app-poster-text-view *ngIf="posterTextModel" [textModel]="posterTextModel"></app-poster-text-view>
  </div>
  <img *ngIf="posterModel.bgType == 'image' && posterModel.bgValue" [src]="posterModel.bgValue" alt='poster'>
</div>
